import React, { useEffect, useState, useRef } from "react";
import {
  ValidationMessage,
  weekDaysInText,
  meetingWeeksInText,
  hasRole,
} from "../../components/Utils";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  CHAPTER_EDIT,
  CHAPTER_UPDATE,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  CITY_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
  CURRENCY_LIST_DROPDOWN,
} from "../../routes/routes";
import { toast } from "react-toastify";
import Form from "react-bootstrap/Form";
import { CHAPTER_UPDATED } from "../../constant/constant";
import { FullPageLoader } from "../../components/common/Loader"; // Import the loader component
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_red.css";
import moment from "moment";
import Select from "react-select";
import { Timepicker } from "timepicker-ui-react";
import "timepicker-ui/main.css";

// Weekly training is hidden for now. Set to true to show it again.
const SHOW_WEEKLY_TRAINING = false;

const ChapterEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [form, setForm] = useState();
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [cityOptions, setCityOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [filter, setFilter] = useState([]);

  const selectStateRef = useRef(null);
  const selectCityRef = useRef(null);
  const selectRegionRef = useRef(null);

  const handleStateClear = () => {
    selectStateRef.current.clearValue();
    selectCityRef.current.clearValue();
    selectRegionRef.current.clearValue();
  };

  const handleCityClear = () => {
    selectCityRef.current.clearValue();
    selectRegionRef.current.clearValue();
  };

  const handleRegionClear = () => {
    selectRegionRef.current.clearValue();
  };

  const daysOptions = [
    { value: 0, label: "Sunday" },
    { value: 1, label: "Monday" },
    { value: 2, label: "Tuesday" },
    { value: 3, label: "Wednesday" },
    { value: 4, label: "Thursday" },
    { value: 5, label: "Friday" },
    { value: 6, label: "Saturday" },
  ];

  const meetingWeekOptions = [
    { value: 1, label: "1st Week" },
    { value: 2, label: "2nd Week" },
    { value: 3, label: "3rd Week" },
    { value: 4, label: "4th Week" },
    { value: 5, label: "5th Week" },
  ];

  /**   *
   * @param {*} input
   * @param {*} callback
   */

  const submit = () => {
    setBtnDisabled(true);
    let requestBody = { ...form };
    if (requestBody.weekly_meeting_time) {
      requestBody.weekly_meeting_time = moment(
        requestBody.weekly_meeting_time,
        ["hh:mm A", "h:mm A", "HH:mm:ss", "HH:mm"],
      ).format("HH:mm:ss");
    }
    axios
      .put(CHAPTER_UPDATE + id, requestBody)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(CHAPTER_UPDATED);
          navigate("/chapters");
        }
      })
      .catch((err) => {
        if (err.response?.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        } else {
          toast.error(err.response?.data?.msg || "Something went wrong");
        }
      })
      .finally(() => {
        setBtnDisabled(false);
      });
  };
  useEffect(() => {
    axios
      .get(CHAPTER_EDIT + id)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          let responseData = res.data.data;

          let meetingWeeks = [];
          if (responseData?.meeting_weeks) {
            if (Array.isArray(responseData.meeting_weeks)) {
              meetingWeeks = responseData.meeting_weeks;
            } else if (typeof responseData.meeting_weeks === "string") {
              try {
                meetingWeeks = JSON.parse(responseData.meeting_weeks);
              } catch (e) {
                meetingWeeks = responseData.meeting_weeks
                  .split(",")
                  .map((v) => Number(v.trim()))
                  .filter((v) => !isNaN(v));
              }
            }
          }

          let meetingWeeksSelected = Array.isArray(meetingWeeks)
            ? meetingWeeks.map((week) => ({
                value: week,
                label: meetingWeeksInText(week),
              }))
            : [];

          let weeklyMeetingDaysSelected =
            responseData?.weekly_meeting_days !== null &&
            responseData?.weekly_meeting_days !== undefined
              ? {
                  value: responseData?.weekly_meeting_days,
                  label: weekDaysInText(responseData?.weekly_meeting_days),
                }
              : null;

          let weeklyMeetingTime = responseData?.weekly_meeting_time
            ? moment(responseData?.weekly_meeting_time, [
                "hh:mm a",
                "HH:mm:ss",
                "HH:mm",
              ]).format("hh:mm A")
            : "";

          setForm({
            id: responseData?.id,
            chapter_name: responseData?.chapter_name || "",
            address: responseData?.address || "",
            country_id: responseData?.country_id,
            country_id_selected: responseData?.country_id
              ? {
                  value: Number(responseData?.country_id),
                  label: responseData?.country_name,
                }
              : null,
            state_id: responseData?.state_id,
            state_id_selected: responseData?.state_id
              ? {
                  value: Number(responseData?.state_id),
                  label: responseData?.state_name,
                }
              : null,
            city_id: responseData?.city_id,
            city_id_selected: responseData?.city_id
              ? {
                  value: Number(responseData?.city_id),
                  label: responseData?.city_name,
                }
              : null,
            region_id: responseData?.region_id,
            region_id_selected: responseData?.region_id
              ? {
                  value: Number(responseData?.region_id),
                  label: responseData?.region_name,
                }
              : null,
            pincode: responseData?.pincode || "",
            status: responseData?.status,
            launching_date: responseData?.launching_date
              ? moment(responseData?.launching_date, "DD/MM/YYYY").format(
                  "DD/MM/YYYY",
                )
              : "",
            rolling_period_months: Number(
              responseData?.rolling_period_months || 12,
            ),
            is_chapter_launched: responseData?.is_chapter_launched,
            is_chapter_already_launched: responseData?.is_chapter_launched,
            meeting_frequency: responseData?.meeting_frequency,
            meeting_weeks: meetingWeeks,
            meeting_weeks_selected: meetingWeeksSelected,
            weekly_meeting_days: responseData?.weekly_meeting_days,
            weekly_meeting_days_selected: weeklyMeetingDaysSelected,
            weekly_meeting_time: weeklyMeetingTime,
            training_frequency: SHOW_WEEKLY_TRAINING ? Number(responseData?.training_frequency || 2) : 2,
            training_day: responseData?.training_day,
            training_day_selected: Number(responseData?.training_frequency) === 1 ? {
              value: Number(responseData?.training_day),
              label: weekDaysInText(responseData?.training_day),
            } : null,
            training_date_of_month: responseData?.training_date_of_month || "",
            training_date_selected: responseData?.training_date_of_month ? {
              value: Number(responseData.training_date_of_month),
              label: String(responseData.training_date_of_month),
            } : null,
            training_time: responseData?.training_time
              ? moment(responseData.training_time, ["hh:mm a", "HH:mm:ss", "HH:mm"]).format("HH:mm:ss")
              : "",
            weekly_meeting_fees: responseData?.weekly_meeting_fees || "",
            currency_id: responseData?.currency_id || "",
            currency: responseData?.currency || "",
            background_color: responseData?.background_color || "#CF2030",
            color: responseData?.color || "#FFFFFF",
          });
          setFilter({
            country_id: responseData?.country_id || null,
            state_id: responseData?.state_id || null,
            city_id: responseData?.city_id || null,
            region_id: responseData?.region_id || null,
          });
        }
      })
      .catch((err) => {
        console.error("Error loading chapter edit data:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [countryRes, stateRes, cityRes, regionRes, currencyRes] = await Promise.all([
          axios.get(COUNTRY_LIST_DROPDOWN),
          axios.get(STATE_LIST_DROPDOWN, { params: filter }),
          axios.get(CITY_LIST_DROPDOWN, { params: filter }),
          axios.get(REGION_LIST_DROPDOWN, { params: filter }),
          axios.get(CURRENCY_LIST_DROPDOWN),
        ]);

        setCountryOptions(countryRes.data.data || []);
        setStateOptions(stateRes.data.data || []);
        setCityOptions(cityRes.data.data || []);
        setRegionOptions(regionRes.data.data || []);
        setCurrencyOptions(currencyRes.data.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [JSON.stringify(filter)]);

  useEffect(() => {
    if (currencyOptions.length > 0 && form?.currency && !form?.currency_id) {
      const matched = currencyOptions.find(
        (opt) => opt.symbol === form.currency || opt.name === form.currency
      );
      if (matched) {
        setForm((prev) => ({
          ...prev,
          currency_id: matched.value,
          currency: matched.symbol,
        }));
      }
    }
  }, [currencyOptions, form?.currency, form?.currency_id]);
  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Circles</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <Link to={"/chapters"}>
                    <span>Circles List</span>
                  </Link>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Edit Circle</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/chapters"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        {/* <div className="demo-inline-spacing d-flex justify-content-end mb-3">
          <Link to={"/chapters"}>
            <button type="button" className="btn btn-dark rounded-pill">
              <i className="bx bx-exit"></i> back
            </button>
          </Link>
        </div> */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                {/* <h5 className="mb-0">Edit Circle</h5> */}
              </div>
              <div className="card-body">
                <form>
                  <div className="row">
                    {hasRole([1]) && (
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="country_id" className="form-label">
                            Country<span className="text-danger">*</span>
                          </label>
                          <Select
                            isClearable
                            options={countryOptions}
                            isDisabled={true}
                            onChange={(selected) => {
                              handleStateClear();
                              setForm({
                                ...form,
                                country_id: Number(selected?.value),
                                country_id_selected: selected,
                                state_id: null,
                                state_id_selected: null,
                                city_id: null,
                                city_id_selected: null,
                                region_id_selected: null,
                                region_id: null,
                              });
                              setFilter({
                                ...filter,
                                country_id: selected?.value,
                                state_id: null,
                                city_id: null,
                                region_id: null,
                              });
                            }}
                            value={form?.country_id_selected}
                          />
                          <ValidationMessage error={errors} name="country_id" />
                        </div>
                      </div>
                    )}

                    {hasRole([1, 6]) && (
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label" htmlFor="state_id">
                            State<span className="text-danger">*</span>
                          </label>
                          <Select
                            isClearable
                            ref={selectStateRef}
                            isDisabled={true}
                            options={stateOptions}
                            onChange={(selected) => {
                              handleCityClear();
                              setForm({
                                ...form,
                                state_id: selected?.value,
                                state_id_selected: selected,
                                city_id: null,
                                city_id_selected: null,
                                region_id_selected: null,
                                region_id: null,
                              });
                              setFilter({
                                ...filter,
                                state_id: selected?.value,
                                city_id: null,
                                region_id: null,
                              });
                            }}
                            value={form?.state_id_selected}
                          />
                          <ValidationMessage error={errors} name="state_id" />
                        </div>
                      </div>
                    )}

                    {hasRole([1, 6, 7]) && (
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label" htmlFor="city_id">
                            City<span className="text-danger">*</span>
                          </label>
                          <Select
                            isClearable
                            ref={selectCityRef}
                            isDisabled={true}
                            options={cityOptions}
                            onChange={(selected) => {
                              handleRegionClear();
                              setForm({
                                ...form,
                                city_id: selected?.value,
                                city_id_selected: selected,
                                region_id_selected: null,
                                region_id: null,
                              });
                              setFilter({
                                ...filter,
                                city_id: selected?.value,
                                region_id: null,
                              });
                            }}
                            value={form?.city_id_selected}
                          />
                          <ValidationMessage error={errors} name="city_id" />
                        </div>
                      </div>
                    )}

                    {hasRole([1, 6, 7, 8, 2]) && (
                      <div className="col-6 mb-3">
                        <label htmlFor="region_id" className="form-label">
                          Region<span className="text-danger">*</span>
                        </label>
                        <Select
                          ref={selectRegionRef}
                          options={regionOptions}
                          isDisabled={true}
                          onChange={(selected) => {
                            setForm({
                              ...form,
                              region_id: selected?.value,
                              region_id_selected: selected,
                            });
                            setFilter({
                              ...filter,
                              region_id: selected?.value,
                            });
                          }}
                          value={form?.region_id_selected}
                        />
                        <ValidationMessage error={errors} name="region_id" />
                      </div>
                    )}

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="chapter_name">
                          Circle Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="chapter_name"
                          placeholder="Name"
                          onChange={(e) =>
                            setForm({ ...form, chapter_name: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, chapter_name: e.target.value })
                          }
                          value={form?.chapter_name || ""}
                        />
                        <ValidationMessage error={errors} name="chapter_name" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="address">
                          Location/Venue
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="address"
                          placeholder="Location"
                          onChange={(e) =>
                            setForm({ ...form, address: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, address: e.target.value })
                          }
                          value={form?.address || ""}
                        />
                        <ValidationMessage error={errors} name="address" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="pincode">
                          Circle Pincode<span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control hide-arrow"
                          id="pincode"
                          placeholder="Pincode"
                          onChange={(e) =>
                            setForm({ ...form, pincode: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, pincode: e.target.value })
                          }
                          value={form?.pincode || ""}
                        />
                        <ValidationMessage error={errors} name="pincode" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="background_color"
                        >
                          Background Color<span className="text-danger">*</span>
                        </label>
                        <input
                          type="color"
                          className="form-control form-control-color"
                          id="background_color"
                          title="Choose your color"
                          value={form?.background_color}
                          onChange={(e) =>
                            setForm({
                              ...form,
                              background_color: e.target.value,
                            })
                          }
                        />
                        <ValidationMessage
                          error={errors}
                          name="background_color"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="color">
                          Color<span className="text-danger">*</span>
                        </label>
                        <input
                          type="color"
                          className="form-control form-control-color"
                          id="color"
                          title="Choose your color"
                          value={form?.color}
                          onChange={(e) =>
                            setForm({ ...form, color: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="color" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div className="col-lg-6 col-md-12 mb-3">
                      <div className="meeting-frequency-section">
                        <label className="form-label">
                          Meeting Frequency
                          <span className="text-danger">*</span>
                        </label>
                        <div className="meeting-frequency-container">
                          <div
                            className={`meeting-frequency-card ${
                              form?.meeting_frequency === 1 ? "active" : ""
                            }`}
                            onClick={() =>
                              setForm({
                                ...form,
                                meeting_frequency: 1,
                                meeting_weeks: [],
                                meeting_weeks_selected: [],
                              })
                            }
                          >
                            <input
                              type="radio"
                              className="meeting-frequency-radio"
                              name="meeting_frequency"
                              id="weekly"
                              value="1"
                              checked={form?.meeting_frequency === 1}
                              onChange={() => {}}
                            />
                            <label
                              htmlFor="weekly"
                              className="meeting-frequency-card-label"
                            >
                              <div className="meeting-frequency-icon">
                                <i className="bx bx-calendar"></i>
                              </div>
                              <div className="meeting-frequency-content">
                                <h6 className="meeting-frequency-title">
                                  Weekly
                                </h6>
                                <p className="meeting-frequency-description">
                                  Same day every week
                                </p>
                              </div>
                            </label>
                          </div>

                          <div
                            className={`meeting-frequency-card ${
                              form?.meeting_frequency === 2 ? "active" : ""
                            }`}
                            onClick={() =>
                              setForm({
                                ...form,
                                meeting_frequency: 2,
                                meeting_weeks: [],
                                meeting_weeks_selected: [],
                              })
                            }
                          >
                            <input
                              type="radio"
                              className="meeting-frequency-radio"
                              name="meeting_frequency"
                              id="flexible"
                              value="2"
                              checked={form?.meeting_frequency === 2}
                              onChange={() => {}}
                            />
                            <label
                              htmlFor="flexible"
                              className="meeting-frequency-card-label"
                            >
                              <div className="meeting-frequency-icon">
                                <i className="bx bx-loader-circle"></i>
                              </div>
                              <div className="meeting-frequency-content">
                                <h6 className="meeting-frequency-title">
                                  Flexible Weeks
                                </h6>
                                <p className="meeting-frequency-description">
                                  Choose any weeks
                                </p>
                              </div>
                            </label>
                          </div>
                        </div>
                        <ValidationMessage
                          error={errors}
                          name="meeting_frequency"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    {form?.meeting_frequency && (
                      <>
                        {form?.meeting_frequency === 2 && (
                          <div className="col-6 mb-3">
                            <label
                              htmlFor="meeting_weeks"
                              className="form-label"
                            >
                              Meeting Weeks
                              <span className="text-danger">*</span>
                            </label>
                            <Select
                              isMulti={true}
                              options={meetingWeekOptions}
                              value={form?.meeting_weeks_selected}
                              onChange={(selected) =>
                                setForm({
                                  ...form,
                                  meeting_weeks: selected
                                    ? selected.map((opt) => opt.value)
                                    : [],
                                  meeting_weeks_selected: selected,
                                })
                              }
                            />
                            <ValidationMessage
                              error={errors}
                              name="meeting_weeks"
                            />
                          </div>
                        )}

                        <div className="col-6 mb-3">
                          <label
                            htmlFor="weekly_meeting_days"
                            className="form-label"
                          >
                            Weekly Meeting Day
                            <span className="text-danger">*</span>
                          </label>
                          <Select
                            options={daysOptions}
                            value={form?.weekly_meeting_days_selected}
                            onChange={(selected) =>
                              setForm({
                                ...form,
                                weekly_meeting_days: Number(selected?.value),
                                weekly_meeting_days_selected: selected,
                              })
                            }
                          />
                          <ValidationMessage
                            error={errors}
                            name="weekly_meeting_days"
                          />
                        </div>

                        <div className="col-6 mb-3">
                          <label
                            htmlFor="weekly_meeting_time"
                            className="form-label"
                          >
                            Meeting Time<span className="text-danger">*</span>
                          </label>
                          <Timepicker
                            id="weekly_meeting_time"
                            className="form-control"
                            placeholder="Select Weekly Meeting Time"
                            options={{
                              clock: { type: "12h" },
                              ui: { clearButton: true },
                            }}
                            defaultValue={form?.weekly_meeting_time}
                            onConfirm={(data) => {
                              const hour = data?.hour;
                              const minutes = data?.minutes;
                              const type = data?.type;
                              let timeStr = `${hour}:${minutes} ${type}`;
                              const formatted = moment(timeStr, [
                                "h:mm A",
                                "HH:mm",
                              ]).format("HH:mm:ss");
                              setForm({
                                ...form,
                                weekly_meeting_time: formatted,
                              });
                            }}
                            onClear={() => {
                              setForm({ ...form, weekly_meeting_time: "" });
                            }}
                          />
                          <ValidationMessage
                            error={errors}
                            name="weekly_meeting_time"
                          />
                        </div>
                      </>
                    )}

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="weekly_meeting_fees"
                        >
                          Weekly Meeting Fees
                          <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <select
                            className="form-select"
                            style={{ maxWidth: "120px", flex: "0 0 120px" }}
                            value={
                              form?.currency_id ||
                              currencyOptions.find(
                                (opt) => opt.symbol === form?.currency || opt.name === form?.currency
                              )?.value ||
                              ""
                            }
                            onChange={(e) => {
                              const val = e.target.value;
                              const selectedOpt = currencyOptions.find((opt) => String(opt.value) === String(val));
                              setForm({
                                ...form,
                                currency_id: val,
                                currency: selectedOpt?.symbol || "",
                              });
                            }}
                          >
                            <option value="">Symbol</option>
                            {currencyOptions.map((opt) => (
                              <option key={opt.value} value={opt.value}>
                                {opt.symbol} - {opt.label.split(" - ")[1]}
                              </option>
                            ))}
                          </select>
                          <input
                            type="number"
                            min="1"
                            className="form-control"
                            id="weekly_meeting_fees"
                            placeholder="Fees"
                            onChange={(e) =>
                              setForm({
                                ...form,
                                weekly_meeting_fees: e.target.value,
                              })
                            }
                            onBlur={(e) =>
                              setForm({
                                ...form,
                                weekly_meeting_fees: e.target.value,
                              })
                            }
                            value={form?.weekly_meeting_fees || ""}
                          />
                        </div>
                        <ValidationMessage error={errors} name="currency" />
                        <ValidationMessage error={errors} name="currency_id" />
                        <ValidationMessage
                          error={errors}
                          name="weekly_meeting_fees"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="launching_date">
                          Circle Launching Date
                          <span className="text-danger">*</span>
                        </label>
                        <Flatpickr
                          className="form-control"
                          disabled={form?.is_chapter_already_launched === 1}
                          options={{
                             dateFormat: "d/m/Y",
                             enableTime: false,
                             minDate:
                               form?.is_chapter_launched === 1 ? null : "today",
                          }}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              launching_date: moment(selected[0]).format(
                                "DD/MM/YYYY",
                              ),
                            })
                          }
                          value={form?.launching_date}
                          placeholder="Select Launching Date"
                        />
                        <ValidationMessage
                          error={errors}
                          name="launching_date"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="rolling_period_months"
                        >
                          Rolling Period (Months)
                          <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          id="rolling_period_months"
                          value={form?.rolling_period_months || 12}
                          onChange={(e) =>
                            setForm({
                              ...form,
                              rolling_period_months: Number(e.target.value),
                            })
                          }
                        >
                          {Array.from({ length: 12 }, (_, i) => i + 1).map(
                            (m) => (
                              <option key={m} value={m}>
                                {m} {m === 1 ? "month" : "months"}
                              </option>
                            ),
                          )}
                        </select>
                        <ValidationMessage
                          error={errors}
                          name="rolling_period_months"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="is_chapter_launched"
                        >
                          Is Circle Launched
                        </label>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          value="1"
                          disabled={form?.is_chapter_already_launched === 1}
                          checked={form?.is_chapter_launched === 1}
                          label=""
                          onChange={(event) => {
                            const statusVal = event.target.checked ? 1 : 0;
                            setForm({
                              ...form,
                              is_chapter_launched: statusVal,
                            });
                          }}
                        />
                        <ValidationMessage
                          error={errors}
                          name="is_chapter_launched"
                        />
                      </div>
                    </div>

                    <div className="col-12">
                    <div className="form-section-box">
                    <div className="form-section-header">
                      <div className="form-section-icon">
                        <i className="bx bx-book-reader"></i>
                      </div>
                      <div>
                        <h6 className="form-section-title">Training Schedule</h6>
                        <p className="form-section-subtitle">Set when this circle's training session happens</p>
                      </div>
                    </div>
                    <div className="row">
                    <div className="col-lg-6 col-md-12 mb-3">
                      <div className="meeting-frequency-section">
                        <label className="form-label">
                          Training Frequency
                          <span className="text-danger">*</span>
                        </label>
                        <div className="meeting-frequency-container">
                          <div
                            className={`meeting-frequency-card ${
                              Number(form?.training_frequency) === 2 ? "active" : ""
                            }`}
                            onClick={() => setForm({ ...form, training_frequency: 2 })}
                          >
                            <input
                              type="radio"
                              className="meeting-frequency-radio"
                              name="training_frequency"
                              id="training_monthly"
                              value="2"
                              checked={Number(form?.training_frequency) === 2}
                              onChange={() => {}}
                            />
                            <label htmlFor="training_monthly" className="meeting-frequency-card-label">
                              <div className="meeting-frequency-icon">
                                <i className="bx bx-calendar"></i>
                              </div>
                              <div className="meeting-frequency-content">
                                <h6 className="meeting-frequency-title">Monthly</h6>
                                <p className="meeting-frequency-description">Same date every month</p>
                              </div>
                            </label>
                          </div>

                          {SHOW_WEEKLY_TRAINING && (
                            <div
                              className={`meeting-frequency-card ${
                                Number(form?.training_frequency) === 1 ? "active" : ""
                              }`}
                              onClick={() => setForm({ ...form, training_frequency: 1 })}
                            >
                              <input
                                type="radio"
                                className="meeting-frequency-radio"
                                name="training_frequency"
                                id="training_weekly"
                                value="1"
                                checked={Number(form?.training_frequency) === 1}
                                onChange={() => {}}
                              />
                              <label htmlFor="training_weekly" className="meeting-frequency-card-label">
                                <div className="meeting-frequency-icon">
                                  <i className="bx bx-loader-circle"></i>
                                </div>
                                <div className="meeting-frequency-content">
                                  <h6 className="meeting-frequency-title">Weekly</h6>
                                  <p className="meeting-frequency-description">Same day every week</p>
                                </div>
                              </label>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-12" />

                    {SHOW_WEEKLY_TRAINING && Number(form?.training_frequency) === 1 ? (
                      <div className="col-6 mb-3">
                        <label className="form-label">
                          Training Day
                          <span className="text-danger">*</span>
                        </label>
                        <Select
                          options={daysOptions}
                          value={form?.training_day_selected}
                          onChange={(selected) => setForm({ ...form, training_day: Number(selected.value), training_day_selected: selected })}
                        />
                        <ValidationMessage error={errors} name="training_day" />
                      </div>
                    ) : (
                      <div className="col-6 mb-3">
                        <label className="form-label">
                          Training Date
                          <span className="text-danger">*</span>
                        </label>
                        <Select
                          options={Array.from({ length: 28 }, (_, index) => ({ value: index + 1, label: String(index + 1) }))}
                          value={form?.training_date_selected}
                          onChange={(selected) => setForm({ ...form, training_date_of_month: Number(selected.value), training_date_selected: selected })}
                        />
                        <ValidationMessage error={errors} name="training_date_of_month" />
                      </div>
                    )}

                    <div className="col-6 mb-3">
                      <label htmlFor="training_time_edit" className="form-label">
                        Training Time
                        <span className="text-danger">*</span>
                      </label>
                      {form?.id && (
                        <Timepicker
                          id="training_time_edit"
                          className="form-control"
                          placeholder="Select Training Time"
                          options={{
                            clock: { type: "12h" },
                            ui: { clearButton: true },
                          }}
                          defaultValue={
                            form?.training_time
                              ? moment(form.training_time, "HH:mm:ss").format("hh:mm A")
                              : ""
                          }
                          onConfirm={(data) => {
                            const hour = data?.hour;
                            const minutes = data?.minutes;
                            const type = data?.type;
                            let timeStr = `${hour}:${minutes} ${type}`;
                            const formatted = moment(timeStr, [
                              "h:mm A",
                              "HH:mm",
                            ]).format("HH:mm:ss");
                            setForm({
                              ...form,
                              training_time: formatted,
                            });
                          }}
                          onClear={() => {
                            setForm({ ...form, training_time: "" });
                          }}
                        />
                      )}
                      <ValidationMessage error={errors} name="training_time" />
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/chapters"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChapterEdit;
